// ============================================================
// useTeachers Hook
// ============================================================

import { useEffect } from 'react';
import useTeacherStore from '@/store/teacherStore';
import { useSchool } from './useSchool';

export function useTeachers(options = {}) {
  const { enabled = true } = options;
  const { schoolId } = useSchool();
  
  const teachers = useTeacherStore((s) => s.teachers);
  const loading = useTeacherStore((s) => s.loading);
  const error = useTeacherStore((s) => s.error);
  const fetchTeachers = useTeacherStore((s) => s.fetchTeachers);

  useEffect(() => {
    if (schoolId && enabled) {
      fetchTeachers(schoolId);
    }
  }, [schoolId, fetchTeachers, enabled]);

  return { teachers, loading, error, refetch: () => fetchTeachers(schoolId, true) };
}
